





















import {Component, Prop, Vue} from 'vue-property-decorator';

import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
@Component({
    components: {
        VueperSlides,
        VueperSlide,
    }
})
export default class ProductGallery extends Vue {
    @Prop() public gallery!: string[];

}
